import type { AuthPort, SessionPort } from '../domain/auth'

const makeLogoutUseCase = (auth: AuthPort, session: SessionPort) => async () => {
	await auth.logout()
	session.set(null)
}

export { makeLogoutUseCase }
